import http from '../../../utils/fetch';

export default {
    baseurl: '/api/swyl/v1/inventoryReport/bscHhptInventoryRecord',
    // 分页查询出入库记录
    selectRecordPage(f) {
        return http({
            url: this.baseurl + '/selectRecordPage',
            method: 'post',
            params: f
        });
    },
    // 获取可用年月列表
    getYearMonths() {
        return http({
            url: this.baseurl + '/getYearMonths',
            method: 'post'
        });
    },
    // 手动同步出入库记录
    syncInventoryRecords() {
        return http({
            url: this.baseurl + '/syncInventoryRecords',
            method: 'post'
        });
    },
    // 根据SAP单号查询订单产品信息
    getOrderProductInfo(sapCode) {
        return http({
            url: this.baseurl + '/getOrderProductInfo',
            method: 'post',
            params: { sapCode: sapCode }
        });
    },
    // 创建线下出库记录
    createOfflineOutbound(f) {
        return http({
            url: this.baseurl + '/createOfflineOutbound',
            method: 'post',
            params: f
        });
    },
    // 导出Excel
    downloadExcel(f) {
        return http({
            url: this.baseurl + '/downloadExcel',
            method: 'get',
            params: f,
            responseType: 'blob'
        });
    },
}
